/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostAnomalySpendTrendWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("CostAnomalySpendTrendWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return CostAnomalySpendTrendWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<CostAnomalySpendTrendWidgetConfiguration>): CostAnomalySpendTrendWidgetConfiguration {
        let obj = Object.assign(new CostAnomalySpendTrendWidgetConfiguration(), model);
        CostAnomalySpendTrendWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostAnomalySpendTrendWidgetConfiguration>): CostAnomalySpendTrendWidgetConfiguration {
        if (!model) return null;
        return CostAnomalySpendTrendWidgetConfiguration.newInstance(<CostAnomalySpendTrendWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostAnomalySpendTrendWidgetConfiguration) {
        if (!obj) return;

        models.CostAnomalySpendTrendWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostAnomalySpendTrendWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CostAnomalySpendTrendWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
